export default "__VITE_ASSET__PDfje$Jo__"